export default {
  name: "LoadingComponent"
};